import { useEffect, useState } from "react";
import UpcomingTab from "./UpcomingTab";
import DraftTab from "./DraftTab";
import HistoryTab from "./HistoryTab";
import TemplatesTab from "./TemplatesTab";
import { useLocation, useNavigate } from "react-router-dom";

const AdminEmailTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const incomingActiveTab = location.state?.selectedTab;
  const [activeTab, setActiveTab] = useState(incomingActiveTab || "upcoming");

  useEffect(() => {
  const tabFromState = location.state?.selectedTab;

  if (!tabFromState) return;

  setActiveTab(tabFromState);

  // clear navigation state so it won't trigger again
  navigate(".", { replace: true, state: {} });

}, [location.state, navigate]);

  const renderTab = () => {
    switch (activeTab) {
      case "upcoming":
        return <UpcomingTab isActive={activeTab === "upcoming"} />;
      case "draft":
        return <DraftTab isActive={activeTab === "draft"} />;
      case "history":
        return <HistoryTab isActive={activeTab === "history"} />;
      case "template":
        return <TemplatesTab isActive={activeTab === "template"} />;
      default:
        return null;
    }
  };

  const getClass = (tab) =>
    activeTab === tab ? "active" : "";

  return (
    <>
      <ul
        className="nav nav-tabs"
        id="WebUserAdminTabs"
        role="tablist"
      >
        <li
          role="presentation"
          className={getClass("upcoming")}
        >
          <a
            onClick={() => setActiveTab("upcoming")}
          >
            Upcoming
          </a>
        </li>

        <li
          role="presentation"
          className={getClass("draft")}
        >
          <a
            onClick={() => setActiveTab("draft")}
          >
            Draft
          </a>
        </li>

        <li
          role="presentation"
          className={getClass("history")}
        >
          <a
            onClick={() => setActiveTab("history")}
          >
            History
          </a>
        </li>

        <li
          role="presentation"
          className={getClass("template")}
        >
          <a
            onClick={() => setActiveTab("template")}
          >
            Template
          </a>
        </li>
      </ul>

      <div className="tab-content">
        {renderTab()}
      </div>
    </>
  );
};

export default AdminEmailTabs;
